import React, { FC } from "react";
import { DatasetScatterProps } from "../charts/interfaces";
import DatasetScatterChart from "../charts/dataset-scatter-chart/DatasetScatterChart";

const ProductTemplateBubbleChart: FC<DatasetScatterProps> = props => {
  return <DatasetScatterChart {...props} bubbleChart />;
};

export default ProductTemplateBubbleChart;
